import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { snapshotRuntime } from "@/lib/twa";

// Capture document.referrer / display-mode BEFORE React Router takes over,
// so we know whether we were launched from the Android TWA wrapper.
snapshotRuntime();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
